var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"w-full w-aside hidden 2xl:flex flex-col bg-white overflow-hidden"},[_c('app-nav'),_c('section',{staticClass:"user flex-shrink-0 p-2"},[_c('app-nav-user')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }